'use strict';
// @ts-check

export function init_artwork_order_selector(): void {
    if (document.getElementById('js-artwork_order_selector')) {
        import('./artwork_uploader').then(module => {
            module.init_artwork_uploaders();

            // Get artwork information when a specific order is selected.
            const sales_orders = document.getElementsByClassName('js-sales-orders-container');
            document.getElementById('js-artwork_order_selector').addEventListener('change', event => {
                $.ceAjax('request', 'index.php?dispatch=tv_artwork.view', {
                    method: 'POST',
                    data: {
                        params: {
                            sales_id: (<HTMLInputElement>event.target).value,
                            reload_js: true
                        }
                    },
                    cache: false,
                    result_ids: 'artwork_results_container',
                    callback: () => {
                        module.init_artwork_uploaders();
                    }
                });

                // Hide sales orders except for selected.
                let selected_order = (<HTMLInputElement>event.target).value;
                for (const sales_order of sales_orders) {
                    sales_order.classList.add('tv-display__none');
                    if (selected_order === sales_order.querySelector('.js-sales-order-id').innerHTML) {
                        sales_order.classList.remove('tv-display__none');
                    } else if (selected_order === '') {
                        sales_order.classList.remove('tv-display__none');
                    }
                }
            });

            // Reinitialize the uploaders when the page is changed.
            const observer = new MutationObserver(module.init_artwork_uploaders);
            observer.observe(document.getElementById('pagination_contents'), { childList: true });
        });
    }
}

export function init_generic_uploader(): void {
    if (document.getElementById('upload_artwork_general')) {
        import('./generic_upload_queue').then(module => {
            const generic_uploader = new module.GenericUploadQueue();
            generic_uploader.init_queue();
            generic_uploader.bind();
        });
    }
}

export function init_design_service_requests(): void {
    if (document.getElementById('design_service_requests')) {
        import('./design_service_requests').then(
            module => new module.DesignServiceRequests()
        );
    }
}
